import "./app.css";

import { initLogoLoader } from "./js/loader";
import { initEventSlider } from "./js/schoolLife";

document.addEventListener("DOMContentLoaded", () => {
	initLogoLoader();
	initEventSlider();
});
